import {push} from 'connected-react-router';

import {changeCourseTab} from '../course/courseActions';
import {COURSE_TABS} from '../course/courseActionTypes';

export const goToLearningTab = () => (dispatch) => {
  dispatch(changeCourseTab({tab: COURSE_TABS.LESSONS}));
  dispatch(push(`/learning${location.search}`));
};
